import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* CSS 변수를 사용하여 다크 모드 색상 팔레트 정의 */
  :root {
    --bg-main: #1d2125;
    --bg-header: #21252b;
    --bg-board: #282c34;
    --bg-list: #3a3f44;
    --bg-card: #282c34;
    --bg-modal: #202326;
    --bg-input: #21252b;

    --text-bright: #d7dae0;
    --text-normal: #abb2bf;
    --text-dark: #5c6370;

    --primary-accent: #61afef;
    --primary-accent-hover: #528bcc;
    --danger-accent: #e06c75;
    --danger-accent-hover: #be5046;

    --border-color: #323842;
    --shadow-light: rgba(0, 0, 0, 0.2);
    --shadow-strong: rgba(0, 0, 0, 0.5);

    /* 폰트 패밀리 변수 추가 */
    --ds-font-family-heading: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif;
  }

  /* 기본 스타일 초기화 및 설정 */
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font: 400 14px/20px var(--ds-font-family-heading);
  }

  body {
    background-color: var(--bg-main);
    color: var(--text-normal);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    color: var(--primary-accent);
    text-decoration: none;
  }

  input, textarea, button {
    font: inherit;
    border: none;
    outline: none;
  }
`;

export default GlobalStyle;

